import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M3 3v18h18", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 16h8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 11h12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 6h3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "BarChartHorizontal";
const BarChartHorizontal = memo(themed(Icon));
export {
  BarChartHorizontal
};
//# sourceMappingURL=bar-chart-horizontal.js.map
